<script>
// IN QUESTO FILE METTIAMO TUTTE LE FUNZIONI CHE ANDREMO A RICHIAMARE GLOBALMENTE
//


export const Utility = {
  methods: {
    get_id_ord() {
      //TODO :CREARE VARIABILE ORDINE APERTO. COSI ACCIDENTALMENTE NON SI SCRIVE IN UN'ALTRO ORDINE
      return this.$route.query["id"];
    },
    getRouteQueryParameter(param) {
      //passare il nome del parametro che vuoi recuperare.
      if (param !== undefined)
        return this.$route.query[param];
      else console.log("$route.query non definito");
    },
    dialogPopUp() {},
    getImageUrl(oggetto) {
      //console.log(oggetto)
      if (oggetto.img_name) {
        let estensione = oggetto.img_name.substr(
          oggetto.img_name.length - 4,
          4
        );
        let img_name = oggetto.img_name.substr(0, oggetto.img_name.length - 4);
        if (oggetto.img_name !== null)
          if (oggetto.fonte === "interno" && estensione === ".ext")
            return (
              ref.urlBucketEsterno +
              oggetto.parent +
              "%2F" +
              img_name +
              "?alt=media"
            );
        if (oggetto.fonte === "interno")
          return (
            ref.urlBucket +
            oggetto.parent +
            "%2F" +
            oggetto.img_name +
            "?alt=media"
          );
        if (oggetto.fonte === "esterno")
          return (
            ref.urlBucketEsterno +
            oggetto.parent +
            "%2F" +
            oggetto.img_name +
            "?alt=media"
          );
      }
    }
  }
};
export default {
  name: "Utility"
};
</script>
  